import * as types from './types';
import createReducer from '../../createReducer';

const initialState = {
  list: [],
  file: null,
  versions: {
    list: [],
    current: {},
    pagination: {},
  },
  pagination: {},
  loading: false,
  qualsDocuments: {},
  fetchingVersion: false,
  fetchingVersions: false,
  fetchedUploadFile: false,
  fetchingDeleteVersion: false,
  fetchedUploadDocument: false,
  fetchingUploadDocument: false,
  // documents v2
  isCreatingDocument: false,
  all: [],
  byId: {},
  isUploading: false,
  // document types
  documentType: {},
  fetchingDocument: false,
  documentTypeLoading: false,
  documentTypeSuccess: false,

  documentTypes: [],
  documentTypesLoading: false,
  documentTypesPagination: {},
};

const documentsReducer = createReducer(initialState)({
  // GET DOCUMENTS BY ID
  [types.FETCH_DOCUMENTS_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_DOCUMENTS_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      qualsDocuments: {
        ...state.qualsDocuments,
        [payload.sourceId]: payload.data,
      },
      loading: false,
    };
  },
  [types.FETCH_DOCUMENTS_BY_ID_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  // CHANGE DOCUMENT STATUS
  [types.FETCH_UPDATE_DOCUMENT_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_UPDATE_DOCUMENT_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      list: payload,
      loading: false,
    };
  },
  [types.FETCH_UPDATE_DOCUMENT_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  // UPLOAD DOCUMENT
  [types.FETCH_UPLOAD_DOCUMENT_REQUEST]: (state) => {
    return {
      ...state,
      fetchedUploadDocument: false,
      fetchingUploadDocument: true,
    };
  },
  [types.FETCH_UPLOAD_DOCUMENT_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      list: payload,
      fetchedUploadDocument: true,
      fetchingUploadDocument: false,
    };
  },
  [types.FETCH_UPLOAD_DOCUMENT_FAILED]: (state) => {
    return {
      ...state,
      fetchedUploadDocument: false,
      fetchingUploadDocument: false,
    };
  },
  [types.FETCH_DOWNLOAD_DOCUMENT_REQUEST]: (state) => {
    return {
      ...state,
    };
  },
  [types.FETCH_DOWNLOAD_DOCUMENT_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      file: payload,
    };
  },
  [types.FETCH_DOWNLOAD_DOCUMENT_FAILED]: (state) => {
    return {
      ...state,
    };
  },
  [types.CREATE_VERSION_REQUEST]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  [types.CREATE_VERSION_SUCCESS]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  [types.CREATE_VERSION_FAILURE]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  [types.FETCH_DOCUMENTS_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_DOCUMENTS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      pagination: payload.pagination,
      byId: payload?.data?.byId,
      all: payload?.data?.all,
      loading: false,
    };
  },
  [types.FETCH_DOCUMENTS_FAILURE]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  [types.FETCH_DOCUMENT_REQUEST]: (state) => {
    return {
      ...state,
      fetchingDocument: true,
    };
  },
  [types.FETCH_DOCUMENT_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      byId: { ...state.byId, [payload.id]: payload.data },
      fetchingDocument: false,
    };
  },
  [types.FETCH_DOCUMENT_FAILURE]: (state) => {
    return {
      ...state,
      fetchingDocument: false,
    };
  },
  [types.FETCH_VERSION_SUCCESS]: (state, { payload }) => {
    const { documentId, ...version } = payload;
    const documentVersions = state.byId[payload.documentId]?.versions || [];
    const index = documentVersions.findIndex((ver) => ver.id === version.id);
    return {
      ...state,
      byId: {
        ...state.byId,
        [payload.documentId]: {
          ...state.byId[payload.documentId],
          versions: [
            ...documentVersions.slice(0, index),
            version,
            ...documentVersions.slice(index),
          ],
        },
      },
      versions: {
        ...state.versions,
        current: payload,
        list: state.versions.list.map((item) => {
          if (item.id === version.id) {
            return version;
          }
          return item;
        }),
      },
    };
  },
  [types.UPDATE_DOCUMENT_REQUEST]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  [types.UPDATE_DOCUMENT_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      byId: { ...state.byId, [payload.id]: payload },
      loading: false,
    };
  },
  [types.UPDATE_DOCUMENT_FAILURE]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  [types.FETCH_VERSION_BY_DOCUMENT_REQUEST]: (state) => {
    return {
      ...state,
      fetchingVersions: true,
    };
  },
  [types.FETCH_VERSION_BY_DOCUMENT_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      versions: {
        ...state.versions,
        list: payload.data,
        pagination: payload.pagination,
      },
      fetchingVersions: false,
    };
  },
  [types.FETCH_VERSION_BY_DOCUMENT_FAILED]: (state) => {
    return {
      ...state,
      versions: {
        ...state.versions,
        list: [],
      },
      fetchingVersions: false,
    };
  },
  // FETCH VERSION BY ID
  [types.RESET_CURRENT_DEFAULT_VERSION]: (state) => {
    return {
      ...state,
      versions: {
        ...state.versions,
        current: null,
      },
    };
  },
  [types.FETCH_VERSION_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      fetchingVersion: true,
    };
  },
  [types.FETCH_VERSION_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      versions: {
        ...state.versions,
        current: payload.data,
      },
      fetchingVersion: false,
    };
  },
  [types.FETCH_VERSION_BY_ID_FAILURE]: (state) => {
    return {
      ...state,
      fetchingVersion: false,
    };
  },
  [types.FETCH_DELETE_VERSION_REQUEST]: (state) => {
    return {
      ...state,
      fetchingDeleteVersion: true,
    };
  },
  [types.FETCH_DELETE_VERSION_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingDeleteVersion: false,
    };
  },
  [types.FETCH_DELETE_VERSION_FAILED]: (state) => {
    return {
      ...state,
      fetchingVersions: false,
    };
  },
  [types.UPLOAD_VERSIONS_FILE_REQUEST]: (state) => {
    return {
      ...state,
      isUploading: true,
      fetchedUploadFile: false,
    };
  },
  [types.UPLOAD_VERSIONS_FILE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      byId: { ...state.byId, [payload.id]: payload },
      versions: {
        ...state.versions,
        current: payload,
      },
      isUploading: false,
      fetchedUploadFile: true,
    };
  },
  [types.UPLOAD_VERSIONS_FILE_FAILURE]: (state) => {
    return {
      ...state,
      isUploading: false,
      fetchedUploadFile: false,
    };
  },
  [types.UPDATE_VERSION_REQUEST]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  [types.UPDATE_VERSION_SUCCESS]: (state, { payload }) => {
    const { documentId, ...version } = payload;
    const documentVersions = state.byId[payload.documentId]?.versions || [];
    let defaultVersion = state.byId[payload.documentId]?.default || {};
    if (version?.id && defaultVersion?.id === version?.id) {
      defaultVersion = { ...defaultVersion, ...version };
    }
    return {
      ...state,
      byId: {
        ...state.byId,
        [payload.documentId]: {
          ...state.byId[payload.documentId],
          default: defaultVersion,
          versions: documentVersions.map((ver) => {
            if (version.id === ver.id) {
              return version;
            }
            return ver;
          }),
        },
      },
      versions: {
        ...state.versions,
        current: version,
        list: state.versions.list.map((item) => {
          if (item.id === version.id) {
            return version;
          }
          return item;
        }),
      },
    };
  },
  [types.UPDATE_VERSION_FAILURE]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  [types.DELETE_DOCUMENT_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      all: state.all.filter((doc) => doc !== payload.documentId),
    };
  },
  [types.RESET_FILE]: (state) => {
    return {
      ...state,
      file: null,
    };
  },

  // DOCUMENT TYPES
  [types.FETCH_DOCUMENT_TYPES_REQUEST]: (state) => {
    return {
      ...state,
      documentTypesLoading: true,
    };
  },
  [types.FETCH_DOCUMENT_TYPES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      documentTypesPagination: payload.pagination,
      documentTypes: payload?.data,
      documentTypesLoading: false,
    };
  },
  [types.FETCH_DOCUMENT_TYPES_FAILURE]: (state) => {
    return {
      ...state,
      documentTypesLoading: false,
    };
  },

  // CREATE DOCUMENT TYPE
  [types.UPDATE_DOCUMENT_TYPE_REQUEST]: (state) => {
    return {
      ...state,
      documentTypeLoading: true,
    };
  },
  [types.UPDATE_DOCUMENT_TYPE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      documentType: payload?.data,
      documentTypeLoading: false,
      documentTypeSuccess: true,
    };
  },
  [types.UPDATE_DOCUMENT_TYPE_FAILURE]: (state) => {
    return {
      ...state,
      documentTypeLoading: false,
      documentTypeSuccess: false,
    };
  },
  [types.CREATE_DOCUMENT_REQUEST]: (state) => {
    return {
      ...state,
      isCreatingDocument: true,
    };
  },
  [types.CREATE_DOCUMENT_SUCCESS]: (state) => {
    return {
      ...state,
      isCreatingDocument: false,
    };
  },
  [types.CREATE_DOCUMENT_FAILURE]: (state) => {
    return {
      ...state,
      isCreatingDocument: false,
    };
  },
});

export default documentsReducer;
